import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { authActions } from '../../_store';
import { FaEye, FaEyeSlash, FaTimesCircle } from 'react-icons/fa';
import { alertActions } from '../../_store';
import ErrorMessage from '../../_components/errorMessage/errorMessage';

export function Login() {
    // Defaults
    const dispatch = useDispatch();

    // State
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [errorLogin, setErrorLogin] = useState(null);

    // Initial setup for navigation props
    dispatch(
        authActions.setNavProps({
            title: 'LOGIN TO SPLENDI',
            button: 'Register',
            action: '../register',
            status: "Don't have an account?",
        })
    );

    useEffect(() => {
        setErrorLogin(null);
    }, []);

    const urlParams = new URLSearchParams(window.location.search);
    const isAdminPrtal = urlParams.get('isAdminPortal');
    if (isAdminPrtal) localStorage.setItem('isAdminPortal', isAdminPrtal);

    const validationSchema = Yup.object().shape({
        username: Yup.string().required('Email is required'),
        password: Yup.string().required('Password is required'),
    });

    const { register, handleSubmit, formState } = useForm({
        resolver: yupResolver(validationSchema),
    });
    const { errors, isSubmitting } = formState;

    const onSubmit = async ({ username, password }) => {
        dispatch(alertActions.clear());
        setErrorLogin(null);

        const reqObj = {
            username: String(username).toLowerCase().trim(),
            password: password,
        };

        try {
            const response = await dispatch(authActions.login(reqObj)).unwrap();

            if (response && response.statusCode === 400) {
                setErrorLogin(response.message);
            }
        } catch (error) {
            error?.status === 500 || error?.response?.status === 500 ?
            setErrorLogin('Oops! It’s taking longer than expected to load your information. Please refresh the page or try again shortly') :            
            dispatch(alertActions.error(error));
        }
    };

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const renderTemplate = () => {
        return (
            <div className='card-body'>
                <h2 className='card-header no-border text-center mb-3'>
                    Sign In
                </h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {errorLogin ? (
                        <div className='mb-3 ml-6'>
                            <ErrorMessage message={errorLogin} />
                        </div>
                    ) : null}
                    <div className='mb-3 ml-6'>
                        <label className='form-label'>Email</label>
                        <input
                            name='username'
                            type='text'
                            {...register('username')}
                            className={`form-control ${
                                errors.username ? 'is-invalid' : ''
                            }`}
                        />
                        <div className='invalid-feedback'>
                            {errors.username?.message}
                        </div>
                    </div>
                    <div className='mb-3 position-relative ml-6'>
                        <label className='form-label'>Password</label>
                        <div className='password-input-container'>
                            <input
                                name='password'
                                type={passwordVisible ? 'text' : 'password'}
                                {...register('password')}
                                className={`form-control ${
                                    errors.password ? 'is-invalid' : ''
                                }`}
                            />
                            <div className='invalid-feedback'>
                                {errors.password?.message}
                            </div>
                            <span
                                className='password-toggle-icon'
                                onClick={togglePasswordVisibility}
                            >
                                {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                    </div>
                    <div className='d-grid gap-2 ml-6 mt-4'>
                        <button
                            disabled={isSubmitting}
                            className='btn btn-black mb-2 w-100'
                        >
                            {isSubmitting && (
                                <span className='spinner-border spinner-border-sm me-1'></span>
                            )}
                            LOGIN
                        </button>
                        <Link to='/forgot-password'>
                            <button className='btn btn-custom-1 text-primary w-100 text-center'>
                                Forgot your password?
                            </button>
                        </Link>
                    </div>
                </form>
            </div>
        );
    };

    return (
        <div className='card no-border m-0 m-md-3 pt-4 pb-5 d-flex align-items-center'>
            {renderTemplate()}
        </div>
    );
}
